import type { ListEventLogsParams } from 'api/admin/eventLogs/listEventLogs'

const ROOT = 'eventLogs'

export const eventLogsKeys = {
  all: [ROOT] as const,
  list: (params: Omit<ListEventLogsParams, 'cursor'> | null) =>
    [ROOT, 'list', params] as const,
}
